<div class="container-fluid loader-container">
    <app-loader *ngIf="loading == true"></app-loader>

    <div class="row" *ngIf="item">
        <div class="col-6">
            <div class="card">
                <div class="card-header d-flex space-between">
                    <h5 class="card-title">Profiel</h5>
                </div>
                <div class="card-body p-0">
                    <table class="table table-striped m-0">
                        <tbody>
                            <tr>
                                <td class="ps-4">Naam</td>
                                <td>{{ item['name'] }}</td>
                            </tr>
                            <tr>
                                <td class="ps-4">E-mail</td>
                                <td>{{ item['email'] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="col-6">
            <div class="card">
                <div class="card-header d-flex space-between">
                    <h5 class="card-title">Wachtwoord wijzigen</h5>
                </div>
                <div class="card-body p-4">
                    <div *ngIf="errorMessage && errorMessage.length"
                        class="alert alert-danger d-flex align-items-center pb-0" role="alert">
                        <ul>
                            <li *ngFor="let error of errorMessage">{{error}}</li>
                        </ul>
                    </div>
                    <div *ngIf="passwordUpdated" class="alert alert-success d-flex align-items-center" role="alert">
                        <div>
                            Wachtwoord is bijgewerkt.
                        </div>
                    </div>
                    <div>
                        <div class="form-group mb-3">
                            <label for="currentPassword">Huidig wachtwoord</label>
                            <input [(ngModel)]="update_password['current_password']" type="password"
                                class="form-control" id="currentPassword" />
                        </div>
                        <div class="form-group mb-3">
                            <label for="newPassword">Nieuw wachtwoord</label>
                            <input [(ngModel)]="update_password['new_password']" type="password" class="form-control"
                                id="newPassword" />
                        </div>
                        <div class="form-group mb-3">
                            <label for="repeatPassword">Herhaal wachtwoord</label>
                            <input [(ngModel)]="update_password['new_password_repeat']" type="password"
                                class="form-control" id="repeatPassword" />
                        </div>
                        <button (click)="savePassword()" type="submit" class="btn btn-primary mt-2">
                            Opslaan
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>